<template>
  <div
    v-show="visible"
    class="vehicle-map-info-panel"
    :style="{ left: `${position.left}px`, top: `${position.top}px` }"
    @click.stop
  >
    <button type="button" class="vehicle-map-info-panel__close" @click="$emit('close')">
      <i class="el-icon-close" />
    </button>
    <VehicleMapInfoCard v-if="currentItem" :item="currentItem" />
    <div v-if="showNavigation" class="vehicle-map-info-panel__footer">
      <button type="button" class="vehicle-map-info-panel__nav" @click.stop="$emit('prev')">
        ‹ {{ $t('home.name69') }}
      </button>
      <span class="vehicle-map-info-panel__count">{{ index + 1 }} / {{ vehicles.length }}</span>
      <button type="button" class="vehicle-map-info-panel__nav" @click.stop="$emit('next')">
        {{ $t('home.name70') }} ›
      </button>
    </div>
  </div>
</template>

<script>
import VehicleMapInfoCard from '@/components/VehicleMapInfoCard'

export default {
  name: 'VehicleMapInfoPanel',
  components: {
    VehicleMapInfoCard,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    vehicles: {
      type: Array,
      default: () => [],
    },
    index: {
      type: Number,
      default: 0,
    },
    position: {
      type: Object,
      default: () => ({ left: 0, top: 0 }),
    },
  },
  computed: {
    currentItem () {
      return this.vehicles[this.index] || null
    },
    showNavigation () {
      return this.vehicles.length > 1
    },
  },
}
</script>

<style lang="scss" scoped>
.vehicle-map-info-panel {
  position: absolute;
  z-index: 10002;
  width: 280px;
  background: #fff;
  border: 1px solid #dcdfe6;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);
  pointer-events: auto;

  &__close {
    position: absolute;
    top: 6px;
    right: 6px;
    z-index: 1;
    width: 24px;
    height: 24px;
    padding: 0;
    border: none;
    background: transparent;
    color: #909399;
    cursor: pointer;
    line-height: 24px;

    &:hover {
      color: #606266;
    }
  }

  &__footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    padding: 8px 10px 10px;
    border-top: 1px solid #ebeef5;
  }

  &__nav {
    flex: 1;
    height: 28px;
    padding: 0 6px;
    border: 1px solid #dcdfe6;
    border-radius: 2px;
    background: #fff;
    color: #606266;
    font-size: 12px;
    cursor: pointer;

    &:hover {
      color: #409eff;
      border-color: #c6e2ff;
      background: #ecf5ff;
    }
  }

  &__count {
    flex-shrink: 0;
    min-width: 48px;
    text-align: center;
    font-size: 12px;
    color: #909399;
  }
}

.vehicle-map-info-panel ::v-deep .vehicle-map-info-card {
  padding: 28px 12px 10px;
}
</style>
